export default {"src":"/_next/static/media/youtube-icon.ddf20c06.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};